// extracted by mini-css-extract-plugin
export var subtitle = "_9e-2";
export var title = "_9e-0";
export var titleNoWrap = "_9e-1";